import { ToolsPanelToggleButton } from "../controls";
import { Typography } from "@mui/material";
import {
    usePortfolioSelection,
    usePortfolioManagement,
    usePortfolioProfile,
} from "../../../shared/contexts/portfolio-context/components/PortfolioContextProvider";
import { useEffect } from "react";

export function CustomImpliedVolatilityToggleButton() {
    const {
        selectedPortfolio,
        isAllPortfoliosSelected,
    } = usePortfolioSelection();
    const {
        saveSelectedPortfolio,
    } = usePortfolioManagement();
    const {
        updateSelectedPortfolio,
    } = usePortfolioProfile();

    const value = selectedPortfolio !== null && selectedPortfolio.portfolioSettings !== null
        ? selectedPortfolio.portfolioSettings.isCustomImpliedVolatilityEnabled
        : false;

    useEffect(() => {
    }, [selectedPortfolio]);

    const onChange = async () => {
        if (isAllPortfoliosSelected) {
            return;
        }

        const newValue = !value;

        if (selectedPortfolio !== null && selectedPortfolio.portfolioSettings !== null) {
            selectedPortfolio.portfolioSettings.isCustomImpliedVolatilityEnabled = newValue;
            updateSelectedPortfolio();
            saveSelectedPortfolio();
        }
    }
    
    return (
        <ToolsPanelToggleButton
            isActivated={value}
            setIsActivated={onChange}
            disabled={isAllPortfoliosSelected}
            tooltipTextWhenActivated="Use real market IV"
            tooltipTextWhenDeactivated="Use custom IV"
        >
            <Typography sx={{ fontSize: '14px', fontWeight: 'bold'}}>
                IV
            </Typography>
        </ToolsPanelToggleButton>
    )
}
